import useAnalytics from "hooks/useAnalytics";
import { AnalyticsPageStack } from "hooks/useAnalytics/pages/stack";

import useStackCreationAnalyticsVersion from "./useStackCreationAnalyticsVersion";

export const useNewStackAnalyticsSegmentEvent = () => {
  const version = useStackCreationAnalyticsVersion();

  const trackSegmentEvent = useAnalytics({
    page: AnalyticsPageStack.StackNew,
    defaultCallbackTrackProperties: {
      version,
    },
  });

  return trackSegmentEvent;
};
